import React, { useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import without from "lodash/without";
import { useTranslation } from "react-i18next";
import { LinkContainer, Icon } from "components/common";
import { Alert, Col, Row, Button } from "components/bootstrap";
import Routes from "routing/Routes";
import usePermissions from "hooks/usePermissions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import AddNotificationForm from "./AddNotificationForm";
import NotificationSettingsForm from "./NotificationSettingsForm";
import NotificationList from "./NotificationList";
import styles from "./NotificationsForm.css";
import commonStyles from "../common/commonStyles.css";
const NotificationsForm = ({ eventDefinition, notifications, defaults, onChange }) => {
  const { t } = useTranslation("event_definitions");
  const sendTelemetry = useSendTelemetry("event-definition-notifications");
  const { isPermitted } = usePermissions();
  const [showAddNotificationForm, setShowAddNotificationForm] = useState(false);
  const toggleAddNotificationForm = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.ADD_CLICKED, {
      app_action_value: "add-notification-button"
    });
    setShowAddNotificationForm(!showAddNotificationForm);
  };
  const handleAssignNotification = (nextNotification) => {
    const nextNotifications = cloneDeep(eventDefinition.notifications);
    nextNotifications.push({
      notification_id: nextNotification
    });
    onChange("notifications", nextNotifications);
    toggleAddNotificationForm();
  };
  const handleRemoveNotification = (notificationId) => {
    const notification = eventDefinition.notifications.find((n) => n.notification_id === notificationId);
    const nextNotifications = without(eventDefinition.notifications, notification);
    onChange("notifications", nextNotifications);
  };
  const notificationIds = eventDefinition.notifications.map((n) => n.notification_id);
  const missingPermissions = notificationIds.filter((id) => !isPermitted(`eventnotifications:read:${id}`));
  if (missingPermissions.length > 0) {
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6, lg: 5 }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("summary_renders.missing_notification_permissions"), " ", /* @__PURE__ */ React.createElement("br", null), " ", missingPermissions.join(", "))));
  }
  if (showAddNotificationForm) {
    return /* @__PURE__ */ React.createElement(
      AddNotificationForm,
      {
        notifications,
        onChange: handleAssignNotification,
        onCancel: toggleAddNotificationForm,
        hasCreationPermissions: isPermitted("eventnotifications:create")
      }
    );
  }
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6, lg: 5 }, /* @__PURE__ */ React.createElement("span", { className: styles.manageNotifications }, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.ALERTS.NOTIFICATIONS.LIST, target: "_blank" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", bsSize: "small" }, t("notifications_form.manage"), " ", /* @__PURE__ */ React.createElement(Icon, { name: "open_in_new" })))), /* @__PURE__ */ React.createElement("h2", { className: commonStyles.title }, t("summary_renders.notifications"), " ", /* @__PURE__ */ React.createElement("small", null, t("fields_form.optional"))), /* @__PURE__ */ React.createElement("p", null, t("notifications_form.description")), /* @__PURE__ */ React.createElement(
    NotificationList,
    {
      eventDefinition,
      notifications,
      onAddNotificationClick: toggleAddNotificationForm,
      onRemoveNotificationClick: handleRemoveNotification
    }
  ), /* @__PURE__ */ React.createElement(NotificationSettingsForm, { eventDefinition, defaults, onSettingsChange: onChange })));
};
export default NotificationsForm;
